export function renderSerializeConfig({
  currentCliVersion,
  namespace,
  srcDir,
  version,
  adminPath,
  schemasPath,
  pagesPath,
  loginPath,
  apiPath,
  databaseProvider,
  databaseMigrationsDir,
  presetsInstalled,
  integrationsInstalled,
  emailProvider,
  storageProvider,
  linter,
  generatedEntities,
  generatedSingles,
  generatedForms
}: {
  currentCliVersion: string
  namespace: string
  srcDir: boolean
  version: number
  adminPath: string
  schemasPath: string
  pagesPath: string
  loginPath: string
  apiPath: string
  databaseProvider: string
  databaseMigrationsDir: string
  presetsInstalled: string
  integrationsInstalled: string
  emailProvider: string
  storageProvider: string
  linter: string
  generatedEntities: string
  generatedSingles: string
  generatedForms: string
}): string {
  return `import { defineConfig } from 'betterstart-cli'

export default defineConfig({
  framework: 'next',
  cliVersion: ${currentCliVersion},

  frameworkConfig: {
    next: {
      namespace: ${namespace},
      srcDir: ${srcDir},
      version: ${version},
      paths: {
        admin: ${adminPath},
        schemas: ${schemasPath},
        pages: ${pagesPath},
        login: ${loginPath},
        api: ${apiPath},
      },
    },
  },

  database: {
    provider: ${databaseProvider},
    migrationsDir: ${databaseMigrationsDir},
  },

  presets: {
    installed: ${presetsInstalled},
  },

  integrations: {
    installed: ${integrationsInstalled},
  },

  email: {
    provider: ${emailProvider},
  },

  storage: {
    provider: ${storageProvider},
  },

  linter: ${linter},

  generated: {
    entities: ${generatedEntities},
    singles: ${generatedSingles},
    forms: ${generatedForms},
  },
})
`
}
